import { api } from "lwc";
import ButtonIcon from "tds/buttonIcon";

class buttonIconLink extends ButtonIcon {
  @api href = null;
  @api rel = null;
  @api target = null;
  @api variant = "tertiary";
}

export default buttonIconLink;
